// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wcN9J","question":"styles_question__h1fIy","inputVisibleButton":"styles_inputVisibleButton__1SyM0","note":"styles_note__1NHRX"};